// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueI18n from 'vue-i18n'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

// import HomeBtn from './components/HomeBtn.vue'

import './assets/styles/common/common.scss'
import './assets/styles/common/animation.scss'
import './assets/styles/PageCommon.scss'

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(VueI18n) // 通过插件的形式挂载
// Vue.component('HomeBtn', HomeBtn)
/* eslint-disable no-new */

const i18n = new VueI18n({
  locale: 'cn-ZH', // 语言标识。通过切换locale的值来实现语言切换（this.$i18n.locale）
  // locale: 'en-US', // 语言标识。通过切换locale的值来实现语言切换（this.$i18n.locale）
  //
  messages: {
    'cn-ZH': require('./common/lang/zh'), // 中文语言包
    'en-US': require('./common/lang/en') // 英文语言包
  },
  fallbackLocale: 'cn-ZH'
})

new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js